import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ApiServiceProvider} from "../../providers/api.service";
import { HomePage } from "../home/home";
import { Storage } from '@ionic/storage';
import { GlobalServiceProvider} from "../../providers/global.service";

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  username: string;
  password: string;
  hasToLogin :boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public api: ApiServiceProvider,
              public storage: Storage,
              public global:GlobalServiceProvider
  ) {

    storage.get('userLoggedIn').then((user)=>{

      if(!user){
        this.storage.set('userLoggedIn', null);
        // this.gotoPage('login');
        this.hasToLogin = true;
      }
      else {

        this.hasToLogin = false;
        this.api.user = user;
        //perform login in background
        this.api.login(user.username, user.password).then(()=>{
          setTimeout(()=>{
            this.navCtrl.push(HomePage);
          },0);
          }).catch((error)=>{

        })

      }
    })

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');


  }

  login(){


    this.api.login(this.username, this.password)
      .then((response)=>{
        console.log(response);
        //redirect to the home page


        //TODO: Don't store the password, have the server return a token that would be valid and provide this instead
        this.storage.set('userLoggedIn', {username:this.username, password:this.password, identificationToken: response.identificationToken});
        //this was a valid user, set it to storage
        this.navCtrl.push(HomePage);
      })
      .catch((error)=>{
        console.log(error);
      })

    // api.login()
  }


}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts